import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from './Dialog';
import Button from './Button';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonVariant?: 'primary' | 'secondary' | 'danger' | 'success' | 'warning' | 'info';
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  confirmButtonVariant = 'primary'
}) => {
  const { t } = useTranslation();
  const defaultConfirmText = confirmText || t('common.actions.confirm');
  const defaultCancelText = cancelText || t('common.actions.cancel');
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
    >
      <div className="p-6">
        <p className="mb-6 text-gray-700 dark:text-gray-300">
          {message}
        </p>
        <div className="flex justify-end space-x-2">
          <Button 
            variant="outlined" 
            onClick={onClose}
          >
            {defaultCancelText}
          </Button>
          <Button 
            variant={confirmButtonVariant === 'danger' ? 'danger' : 'primary'} 
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {defaultConfirmText}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;